import { render, staticRenderFns } from "./ClientCMSProductRoot.vue?vue&type=template&id=337ba1a2&scoped=true&"
import script from "./ClientCMSProductRoot.vue?vue&type=script&lang=js&"
export * from "./ClientCMSProductRoot.vue?vue&type=script&lang=js&"
import style0 from "./ClientCMSProductRoot.vue?vue&type=style&index=0&id=337ba1a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ba1a2",
  null
  
)

export default component.exports